










































































import mixins from 'vue-typed-mixins';
import S3Mixin from '@/components/mixins/s3';
import E2EMixin from '@/components/mixins/E2EMixin';
import HeaderHamburger from '@/containers/header-hamburger/index.vue';
import Headwayapp from '@/components/Headwayapp.vue';
import CvShareModal from '@/containers/modals/cv-share/index.vue';
import { PropType } from 'vue';
import { Cv } from 'gen';

type HeaderItem = {
  url: string;
  icon: string;
  text: string;
  isSpaApp: boolean;
  isActive: boolean;
  klass: string;
};
export default mixins(S3Mixin, E2EMixin).extend({
  components: {
    HeaderHamburger,
    Headwayapp,
    CvShareModal,
  },
  props: {
    // Has value when a page is `/app/cvs/:id`
    cv: {
      type: Object as PropType<Cv>,
      default: null,
    },
  },
  data() {
    return {
      cvShareModalOpened: false,
    };
  },
  computed: {
    isCvPage() {
      return !!this.cvId;
    },
    cvId() {
      return this.cv?.id;
    },
    headerLinks(): HeaderItem[] {
      const currentPath = this.$route.path;
      const makeHeaderItem = (
        url,
        icon,
        text,
        isSpaApp,
        klass,
        isActiveExact = false
      ): HeaderItem => {
        return {
          url,
          icon,
          text,
          isSpaApp,
          isActive: isActiveExact
            ? currentPath === url
            : currentPath.startsWith(url),
          klass,
        };
      };

      const editUrl = `/app/cvs/${this.cvId}`;
      const designUrl = `/app/cvs/${this.cvId}/design`;
      const settingUrl = `/app/cvs/${this.cvId}/setting`;
      const previewUrl = `/app/cvs/${this.cvId}/preview`;

      // avoid to set active highlight on each page
      const isDesignsPage = currentPath.startsWith(designUrl);
      const isPreviewPage = currentPath.startsWith(previewUrl);
      const isSettingsPage = currentPath.startsWith(settingUrl);

      return this.isCvPage
        ? [
            makeHeaderItem(
              editUrl,
              'fa-pencil-alt',
              '編集',
              true,
              '',
              isSettingsPage || isDesignsPage || isPreviewPage
            ),
            makeHeaderItem(
              designUrl,
              'fa-paint-brush',
              'デザイン',
              true,
              'pc',
              true
            ),
            makeHeaderItem(
              previewUrl,
              'fa-search-plus',
              'プレビュー',
              true,
              true
            ),
            makeHeaderItem(settingUrl, 'fa-cog', '設定', true, '', true),
          ]
        : [
            makeHeaderItem(
              `/app/cvs`,
              'fa-file-alt',
              'ダッシュボード',
              true,
              '',
              true
            ),
          ];
    },
    cvPdfUrl() {
      return this.cv ? `/p/${this.cv.original_path}.pdf` : null;
    },
  },
});
